import { co2 } from './common';

export default {
  'consumption.co2': `${co2} Emissionen gesamt (kombiniert)`,
  'consumption.energy': 'Stromverbrauch gesamt (kombiniert)',
  'consumption.fuel': 'Kraftstoffverbrauch gesamt (kombiniert)',
  'footnotes.local': '',
  'footnotes.wltp':
    'Die angegebenen Werte wurden nach dem vorgeschriebenen Messverfahren ermittelt. Es handelt sich um „WLTP-CO2-Werte“ i. S. v. Art. 2 Nr. 3 Durchführungsverordnung (EU) 2017/1153. Die Kraftstoffverbrauchswerte wurden auf Basis dieser Werte errechnet. Der Stromverbrauch wurde auf der Grundlage VO 683/2008/EG ermittelt. Die Angaben beziehen sich nicht auf ein einzelnes Fahrzeug und sind nicht Bestandteil des Angebots, sondern dienen allein Vergleichszwecken zwischen verschiedenen Fahrzeugtypen. Die Werte variieren in Abhängigkeit der gewählten Sonderausstattungen und können sich von den finalen Werten des bestellten bzw. ausgelieferten Fahrzeugs unterscheiden. Tippfehler vorbehalten.',
  'footnotes.nedc': '',
  'footnotes.emissions.appendix':
    'Weitere Informationen zum offiziellen Kraftstoffverbrauch und zu den CO2-Emissionen neuer Fahrzeuge erhalten Sie bei Ihrem Mercedes-Benz Partner.',
  'search.input.label': 'Ihr Suchbegriff / Konfigurator OnlineCode',
  'search.result.buy-online': 'Online kaufen',
  'search.results': 'Kein Suchergebnis gefunden | {count} Suchergebnis | {count} Suchergebnisse',
  'search.results.backup': 'Keine genauen Übereinstimmungen gefunden. Ähnliche Seiten ansehen:',
  'search.results.none.summary':
    'Für diesen Suchbegriff sind keine Suchergebnisse vorhanden. Bitte versuchen Sie es erneut mit einem anderen Suchbegriff.',
  'search.show-more': 'Mehr anzeigen',
  'search.unavailable': 'Die Suche ist derzeit nicht verfügbar.',
  'search.results.count': '{count} Suchergebnisse',
  'search.results.offer': 'Beliebte Angebote für "{query}":',
  'search.result.new': 'Neu',
  'search.result.consumption': 'Verbrauch',

  'watch.video': 'Das Video anschauen',
  'input.recently': 'Kürzlich gesucht',
  'input.help.title': 'Wonach sollten Sie suchen?',
  'input.help.text':
    'Suche unter Verwendung von Fahrzeugart, Modell, Konfigurationscodes oder nach Zubehör, anderen Produkten und Informationen',

  'search.result.grid': 'Raster',
  'search.result.list': 'Liste',

  'input.placeholder': 'Ihr Suchbegriff / Configurator OnlineCode',

  // new part
  'suggestions.all_search_results': 'Alle Suchergebnisse',
  'suggestions.all_search_results_for': 'Alle Ergebnisse anzeigen für',
  'suggestions.in': 'in',

  all: 'Alle',
  UCOS: 'Gebrauchtwagen Online Store',
  PASSENGER_CARS: 'PKW',
  VANS: 'Vans',
  NCOS: 'Neuwagen Online Store',
  VIDEO: 'Videos',
  DEALER_LOCATOR: 'Händlersuche',
  CONFIGURATOR: 'Mercedes-Benz Car Configurator',
  TEST_DRIVE: 'Probefahrt',
  VEHICLE_SEARCH: 'Gebrauchtfahrzeugsuche',
  COLLECT: 'Collection & Zubehör',
  CONNECT: 'Mercedes me Store',
  didyoumean: 'Meinten Sie',
  ACCESSORIES: 'Auto Zubehör',

  //Empty page
  'support.check': 'Bitte prüfen Sie auf Tippfehler oder versuchen Sie es noch einmal mit einem anderen Begriff.',
  'support.no.results': 'Es sind keine Suchergebnisse für diesen Suchbegriff vorhanden.',
  'support.no.results.term': 'Keine Ergebnisse gefunden',
  'support.chat': 'Sie finden nicht, wonach Sie suchen? Bitte nutzen Sie unseren ',
  'support.chat.with.us': 'Online-Chat-Support',
};
